/* eslint-disable no-undef */
export default {
	name: "active-inactive-radio-buttons",
	props: ["activeInactiveKey", "componentId"],
	emits: ["activeInactiveSelected"],
	data() {
		return {
			activeOrInactiveSelectedKey: 1,
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
		};
	},
	methods: {
		onActiveOrInactiveSelect(){
			this.$emit("activeInactiveSelected", this.activeOrInactiveSelectedKey);
		}
	},
	mounted: function () {
		
	},
	watch: {
		activeInactiveKey: {
			handler: function () {
				console.log("activeInactiveKey", this.activeInactiveKey);
				this.activeOrInactiveSelectedKey = this.activeInactiveKey;
			},
			immediate: true,
			deep: true
		},
	}
};